import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import '@styles/main.less';

import RegionsList from './Regions';
import ViewRegion from './ViewRegion';

function RegionsPage(props) {
  const {
    match: { url }
  } = props;

  return (
    <Switch>
      <Route exact path={`${url}/`} component={RegionsList} />
      <Route path={`${url}/:id`} component={ViewRegion} />
    </Switch>
  );
}

RegionsPage.propTypes = {
  match: PropTypes.object
};

export default RegionsPage;
